
import {updateFilterUrl, parseFilterUrl} from './functions/url';
import {filterItems} from './functions/filters';

import React, { useState, useEffect } from 'react';

import Grid from './components/Grid';
import TopFilters from './components/TopFilters';
import SideFilters from './components/SideFilters';
import SideFiltersNav from './components/SideFiltersNav';
import SelectedFilters from './components/SelectedFilters.js';
import Pagination from './components/Pagination';

import SelectedTopFilter from './components/SelectedTopFilter.js';
import TotalResults from './components/TotalResults.js';
import TotalResultsBottom from './components/TotalResultsBottom.js';

import HiddenSearch from './components/HiddenSearch.js';

import { FilterContextProvider } from "./context/context";



function FilterUI(props) {

  const {
    filter_form,
    items,
    active_filters,
    current_page
  } = props;


  const [selectedFilters, setSelectedFilters] = useState(filter_form);
  const [activeFilters, setActiveFilters] = useState(active_filters);
  const [filteredItems, setFilteredItems] = useState(items);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(current_page);
  const [totalItems, setTotalItems] = useState(filteredItems.length);
  const states = {
    selectedFilters, setSelectedFilters,
    activeFilters, setActiveFilters,
    filteredItems, setFilteredItems,
    searchQuery, setSearchQuery,
    currentPage, setCurrentPage,
    totalItems, setTotalItems
  };

  useEffect(() => {
    setFilteredItems(items);
  }, [items]);

  useEffect(() => {
    updateFilterUrl(selectedFilters, currentPage);
    let filter_items = filterItems(items, selectedFilters, searchQuery);
    setFilteredItems(filter_items);

    let totalPageCount = Math.ceil(filter_items.length / 12);
    if (currentPage > totalPageCount ){
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }


  }, [selectedFilters, searchQuery, currentPage]);




  const toggleFilterPanel = (panel) => {
    let active_filters = activeFilters;
    if (active_filters.active_panel === panel && active_filters.mobile_open ){
      active_filters.mobile_open = false;
    } else {
      active_filters.mobile_open = true;
    }

    active_filters.active_panel = panel;

    setActiveFilters(
      {...activeFilters},
      active_filters
    )
  }


  const closeFilterPanel = () => {
      let active_filters = {
          mobile_open: false,
          active_panel: 'side_filter',
          top_filter_open: false,
          side_filter_open: false,
          active_side_filter: '',
          active_date_panel: ''
      };


      setActiveFilters(
        active_filters
      )
  }

  const toggleMobileFilters = () => {
      let active_filters = activeFilters;
      active_filters.mobile_open = !activeFilters.mobile_open;



      setActiveFilters(
        {...activeFilters},
        active_filters
      )
  }


  return (
    <>


      <FilterContextProvider value={states}>
        <SideFilters form={filter_form} />
        <Grid />
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={filteredItems.length}
          pageSize={12}
          onPageChange={page => setCurrentPage(page)}
        />


      </FilterContextProvider>
    </>
  );
}

export default FilterUI;
